// ContentContext.js
import React, { createContext, useContext, useState } from "react";

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [pageHeading, setPageHeading] = useState("Partner Portal");

  const collection = {
    pageHeading, 
    setPageHeading
  };

  return (
    <ContentContext.Provider value={collection}>{children}</ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
